import React from 'react';
import { Backdrop, BackdropProps, DotProgress, Box, FlexBox, Typography, color } from '@kis-technologies/kis-ui';

interface Props {
  message?: string;
  style?: Partial<BackdropProps['style']>;
}

/**
 * Overlay used during content loading
 */

export const LoadingOverlay = (props: Props) => {
  const onEl = (el: HTMLElement) => {
    const { style } = el;
    style.background = '#EFEFEF';
    style.marginTop = '120.90px';
    style.height = 'calc(100% - 120.90px)';
  };
  return (
    <Backdrop onEl={onEl} sx={props.style} open>
      <FlexBox maxWidth={900} direction="column" align="center">
        <Box flexOverride="none" margin="0 0 5">
          {/* Loading Message */}
          <Typography fontSize={64} fontWeight={600} align="center">
            {props.message}
          </Typography>
        </Box>

        {/* Loading SVG */}
        <DotProgress size={32} color={color.LIGHT_GRAY} />
      </FlexBox>
    </Backdrop>
  );
};
